import { render } from "./DoubleRange.vue?vue&type=template&id=6e3e7d51&bindings={\"valuemin\":\"props\",\"valuemax\":\"props\",\"step\":\"props\",\"valuea\":\"data\",\"valueb\":\"data\",\"onInputMax\":\"options\",\"onInput\":\"options\",\"reinit\":\"options\",\"sliderMin\":\"options\",\"sliderMax\":\"options\",\"sortedvalues\":\"options\"}"
import script from "./DoubleRange.vue?vue&type=script&lang=js"
export * from "./DoubleRange.vue?vue&type=script&lang=js"

import "./DoubleRange.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script